// extracted by mini-css-extract-plugin
export default {"div__1":"Purchase_div__1__9g2xR"};